export default {
    VUE_APP_API_PATH: '/api',
    VUE_APP_ALLOW_USER_REGISTRATION: 'false',
    VUE_APP_PASSWORD_STRENGTH: '2',
    VUE_APP_USE_LDAP: 'false'
}
